// Pure pagination offset maths, extracted so it can be unit-tested independently
// of the (Glimmer) paper-data-table-pagination component.

// startOffset is the 1-based index of the first row shown on the current page.
export function startOffset(page: number, limit: number): number {
  return Math.max((page - 1) * limit + 1, 1);
}

// endOffset is the index of the last row shown on the current page, capped at
// `total` when a total is provided.
export function endOffset(page: number, limit: number, total?: number): number {
  const end = startOffset(page, limit) + limit;
  return total ? Math.min(end, total) : end;
}
